import React from "react"
import { mk_widget, IOWidget, Action } from "widgets-for-react"
import { CMSState } from "../../../../cms/blocks/types.gen"
import { PublicSite_CustomPageData } from "../../../application.mod"
import { PublicSiteState } from "../../../../public_site.main.mod"

export type FactsAndFiguresBlockItem = {
    amount: string
    label: string
    intro: string
}

export type FactsAndFiguresAttributes = {
    blockName: 'vidda/facts-and-figures'
    items: Array<FactsAndFiguresBlockItem>
}

export interface FactsAndFiguresInterface {
    blockName: 'vidda/facts-and-figures'
    attrs: FactsAndFiguresAttributes
}

export type FactsAndFiguresBlockProps<extra_images> = FactsAndFiguresAttributes

export type FactsAndFiguresBlockStyle = Partial<{
    block_classname: string
    inner_classname: string
    header_classname: string
    title_classname: string
    content_classname: string
    intro_classname: string
    visual_classname: string
}>

export function FactsAndFiguresBlock<customBlockData, extra_images>(
    props: FactsAndFiguresBlockProps<extra_images>,
    options?: { style: FactsAndFiguresBlockStyle; key?: string }
    ): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
        return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
            return mk_widget({
              run: _ => (
                <section className="block block--facts">
                  <div className="block__inner grid--block container--xl">
                    <ul className="block__list list">
                      {props.items.map(item => (
                        <li className="list__item">
                          <h2 className="list__title typo--4xl">{item.amount}</h2>
                          <p className="list__label typo--m">{item.label}</p>
                          <p className="typo--xs text--styled" dangerouslySetInnerHTML={{__html: item.intro}} />
                        </li>
                      ))}
                    </ul>
                  </div>
                </section>
              )
            });}}